import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "myp-criteria-configuration",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "myp-criteria-configuration" */ "./components"
        ),
        import(
          /* webpackChunkName: "myp-criteria-configuration" */ "Settings/components/MYPCriteriaConfiguration/modules/MYPCriteriaConfigurationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "mypCriteriaConfiguration",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
